import { CopyAmountToAllBookingItem } from "@/models/api/commands/booking/CopyAmountToAllBookingItem";

export class CopyPurchaseNetPriceToAllBookingItem extends CopyAmountToAllBookingItem {
  CommandName = "CopyPurchaseNetPriceToAllBookingItem";

  constructor(
    sessionId: string,
    operationId: string,
    purchaseNetPriceInCurrency: number,
    currency: string,
    purchaseNetPrice: number,
    exchangeDate: string | null,
    exchangeRate: number | null
  ) {
    super(sessionId, operationId, purchaseNetPriceInCurrency, currency, purchaseNetPrice, exchangeDate, exchangeRate);
  }
}
